module.exports = __webpack_public_path__ + "assets/img/00037.72e4ff05.png";